import { Box, Typography } from '@mui/material';
import { useAppSelector } from 'hooks';
import { ProfessionProforientationGenericEventCard } from 'portfolio3/features/pdf/components/cards';
import { ProforientationMappedEventData } from 'portfolio3/features/proforientation/model/selectors/events';
import { activeFormatSelector } from 'selectors/drawers';

type EventExcursionsSectionProps = {
  data: ProforientationMappedEventData[];
};

const EventExcursionsSection = ({ data }: EventExcursionsSectionProps) => {
  const format = useAppSelector(activeFormatSelector);

  return (
    <Box className="event-excursions">
      <Typography variant="Headings/H5">Экскурсии к работодателю</Typography>
      <Box marginTop="16px" className="event-excursions__content">
        <Box display="grid" gridTemplateColumns={format === 'horizontal' ? '1fr 1fr' : '1fr'} gap="16px">
          {data.map((event, index) => {
            const key = `${event.date}-${event.name}-${index}`;
            return (
              <ProfessionProforientationGenericEventCard
                key={key}
                date={event.date}
                title={event.name}
                subtitle={event.organizer}
                industry={event.industry}
              />
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default EventExcursionsSection;
